import {
    queryFormula,
    getFormulaDrugReturn,
    editDrugReturn,
    formulaPage,
    formulaDetail,
    upDateDeliveryNumber,
    refuseFormula,
    receiveFormula,
    getReturnGoodsList,
    returnGoodsExport,
    getFormulatingPrescription,
    getTransportOrderInfo,
    getTransPortOrderTimeList,
    getTransPortStepDetail
} from "../../api/formula";

class formulaDTO {
    // 查询配方单
    static queryFormula(params) {
            return new Promise((resolve, reject) => {
                queryFormula(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 获取退药记录
    static getFormulaDrugReturn(params) {
            return new Promise((resolve, reject) => {
                getFormulaDrugReturn(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 编辑退药
    static editDrugReturn(params) {
            return new Promise((resolve, reject) => {
                editDrugReturn(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 分页查询配方单
    static formulaPage(params) {
            return new Promise((resolve, reject) => {
                formulaPage(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 分页查询配方单
    static formulaDetail(params) {
            return new Promise((resolve, reject) => {
                formulaDetail(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 更新快递单号
    static upDateDeliveryNumber(params) {
            return new Promise((resolve, reject) => {
                upDateDeliveryNumber(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 拒绝配方单
    static refuseFormula(params) {
            return new Promise((resolve, reject) => {
                refuseFormula(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 收方
    static receiveFormula(params) {
            return new Promise((resolve, reject) => {
                receiveFormula(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 获取退货数据
    static getReturnGoodsList(params) {
            return new Promise((resolve, reject) => {
                getReturnGoodsList(params).then((res) => {
                    resolve(res);
                });
            });
        }
        // 获取退货数据
    static returnGoodsExport(params, config) {
            return new Promise((resolve, reject) => {
                returnGoodsExport(params, config).then((res) => {
                    resolve(res);
                });
            });
        }
        // 查询订单配方中的配方单
    static getFormulatingPrescription(params) {
        return new Promise((resolve, reject) => {
            getFormulatingPrescription(params).then((res) => {
                resolve(res);
            });
        });
    }
        // 查询订单配方中的配方单物流填写的信息
    static getTransportOrderInfo(params) {
        return new Promise((resolve, reject) => {
          getTransportOrderInfo(params).then((res) => {
                resolve(res);
            });
        });
    }
        // 查询物流发货时间列表
    static getTransPortOrderTimeList(params) {
        return new Promise((resolve, reject) => {
          getTransPortOrderTimeList(params).then((res) => {
                resolve(res);
            });
        });
    }
        // 查询物流跟踪信息详情
    static getTransPortStepDetail(params) {
        return new Promise((resolve, reject) => {
          getTransPortStepDetail(params).then((res) => {
                resolve(res);
            });
        });
    }
}

export { formulaDTO };